import { render, staticRenderFns } from "./Recepcion.vue?vue&type=template&id=635e0ed0&scoped=true&"
import script from "./Recepcion.vue?vue&type=script&lang=js&"
export * from "./Recepcion.vue?vue&type=script&lang=js&"
import style0 from "./Recepcion.vue?vue&type=style&index=0&id=635e0ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e0ed0",
  null
  
)

export default component.exports